import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import "../FilterRow.scss";
import { useTargetV2Context } from "pages/TargetV2/context/targetV2.context";
import {
  FilterItem,
  SubGroupFilterItem,
} from "pages/TargetV2/types/targetV2.types";
import DropDownSelectFilter from "../dropdownSelectFilter/DropDownSelectFilter";
import { DraggableStateSnapshot } from "react-beautiful-dnd";
import SelectFilter from "../SelectFilter";
import { useTranslation } from "react-i18next";


type CallFilterRowProps = {
  name: string;
  filtersSelected: Array<string>;
  filters: Array<string>;
  id: number;
  index: number;
  level: number;
  isMandatory?: boolean;
  snapchot: DraggableStateSnapshot;
  isResponsive: boolean;
  parentItem: SubGroupFilterItem;
  filterItem: FilterItem;
};

const CallFilterRow: FC<CallFilterRowProps> = ({
  name,
  filtersSelected,
  filters,
  id,
  index,
  level,
  isMandatory,
  snapchot,
  isResponsive,
  parentItem,
  filterItem,
}) => {
  const [isExpandFilter, setIsExpandFilter] = useState<boolean>(false);

  const {
    handleUpdateFilterSelected,
    isMissingMandatoryFields,
  } = useTargetV2Context();

  const refDropDownItem = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (
        refDropDownItem.current &&
        !refDropDownItem.current.contains(e.target)
      ) {
        setIsExpandFilter(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [setIsExpandFilter]);

  const handleExpandFilter = useCallback(() => {
    setIsExpandFilter((state) => !state);
  }, []);

  const handleUpdateFilterClick = useCallback(
    (filter: string) => {
      let action: "Add" | "Remove" = "Add";

      if (
        filterItem.filtersSelected.some(
          (filterSelected) => filterSelected === filter
        )
      ) {
        action = "Remove";
      }

      handleUpdateFilterSelected(id, index, action, filter, level, name);
    },
    [id, index, filterItem, handleUpdateFilterSelected, level, name]
  );

  return (
    <Box className="filter-row-container" style={{ marginRight: "36px" }}>

      {isMandatory && name !=="Journey Id" && <Box className="mandatory-wrapper">{t("mandatory")}</Box>}
      
      <Box className="filter-list-wrapper">
        <Box display="flex" width="140px" gap="4px" alignItems="center">
          <Box
            className="filter-name"
          >
            {name}
          </Box>
        </Box>
        <Box position="relative" width="100%" ref={refDropDownItem}>
          <SelectFilter
            handleExpandFilter={handleExpandFilter}
            filtersSelected={filtersSelected}
            isExpandFilter={isExpandFilter}
            isMandatory={isMandatory ?? false}
            handleUpdateFilterClick={handleUpdateFilterClick}
          />
             
          {isMandatory &&
            filtersSelected.length < 1 &&
            isMissingMandatoryFields && (
              <Box className="mandatory-missing">
                The {name} need to be selected
              </Box>
            )}

          {isExpandFilter && (
            <DropDownSelectFilter
              isMulti={!filterItem.multiSelect}
              handleUpdateFilter={handleUpdateFilterClick}
              filters={filterItem.filters}
              filtersSelected={filterItem.filtersSelected}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CallFilterRow;
